<template>
  <h2 class="h1 text-center">{{ title }}</h2>
  <div class="catbox-grid" >
    <div class="catbox-padding" v-for="(item) in data">
      <a class="catbox" :href="item.link">
        <div class="catbox-text">
          <h3>{{ item.name }}</h3>
          <p>Shop Now <img  width="24" height="24" src="https://us.evocdn.io/dealer/1334/content/media/My_Theme/ob-icon-arrow-circle-right.svg" /></p>
        </div>
        <div class="catbox-image">
          <img :src="item.image" :alt="item.title" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: Object
  },
  data() {
    return {
      arrowIcon: '',
    };
  },
  methods: {
    templateFunction: () => {

    },
  },
}
</script>
